module.exports = __webpack_public_path__ + "blank.html";


//////////////////
// WEBPACK FOOTER
// ./app/blank.html
// module id = 2
// module chunks = 0